<template>
  <div id="agreement_contract">
    <p class="user-output">
      {{ $t("contract.agreement.paragraphOne", { description }) }}.
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    agreement() {
      return this.$store.state.contract.agreement;
    },
    description() {
      return this.agreement.description !== ""
        ? this.agreement.description
        : this.$t("contract.agreement.placeholder.description");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/contract/AgreementOutput.vue